import { render } from "./BananaButton.vue?vue&type=template&id=d3362630&scoped=true"
import script from "./BananaButton.vue?vue&type=script&lang=js"
export * from "./BananaButton.vue?vue&type=script&lang=js"

import "./BananaButton.vue?vue&type=style&index=0&id=d3362630&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d3362630"]])

export default __exports__